
class SoundManager {
  private static instance: SoundManager;
  private sounds: Map<string, HTMLAudioElement> = new Map();
  private enabled: boolean = true;

  private constructor() {
    // Hidden sounds for the experience
    this.load('hover', 'https://www.soundjay.com/buttons/button-28.mp3');
    this.load('select', 'https://www.soundjay.com/buttons/button-3.mp3');
    this.load('transition', 'https://www.soundjay.com/buttons/button-37.mp3');
    this.load('whoosh', 'https://www.soundjay.com/free-music/whoosh-01.mp3');
  }

  static getInstance() {
    if (!SoundManager.instance) {
      SoundManager.instance = new SoundManager();
    }
    return SoundManager.instance;
  }

  load(name: string, url: string) {
    const audio = new Audio(url);
    audio.volume = 0.5;
    this.sounds.set(name, audio);
  }

  play(name: string, volume = 0.5) {
    if (!this.enabled) return;
    const sound = this.sounds.get(name);
    if (sound) {
      sound.currentTime = 0;
      sound.volume = volume;
      sound.play().catch(e => console.warn(`SoundManager: Could not play ${name}`, e));
    }
  }

  toggle(enabled?: boolean) {
    this.enabled = enabled !== undefined ? enabled : !this.enabled;
  }
}

export const sounds = SoundManager.getInstance();
